// olap-client/src/components/chat/ChatSettings.jsx
import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Context } from '../..';

const ChatSettings = observer(() => {
  const { chat } = useContext(Context);

  if (!chat.activeChat || !chat.showRightSidebar) return null;

  const getCompanionName = (chatItem) => {
    if (chatItem.type === 'private') {
      if (chatItem.companion) {
        const name = chatItem.companion.name || '';
        const surname = chatItem.companion.surname || '';
        return `${name} ${surname}`.trim() || chatItem.companion.email;
      }
      return 'Собеседник';
    }
    return chatItem.name || 'Чат';
  };

  return (
    <div style={{
      width: '320px',
      borderLeft: '1px solid #e4e4e5',
      background: '#ffffff',
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto'
    }}>
      {/* Шапка */}
      <div style={{
        padding: '20px',
        borderBottom: '1px solid #e4e4e5',
        textAlign: 'center'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          background: '#3390ec',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '32px',
          margin: '0 auto 10px'
        }}>
          👤
        </div>
        <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
          {getCompanionName(chat.activeChat)}
        </div>
        <div style={{ fontSize: '13px', color: '#707579', marginTop: '4px' }}>
          {chat.activeChat.type === 'private' ? 'В сети' : 'Групповой чат'}
        </div>
      </div>

      {/* Действия */}
      <div style={{ padding: '10px 0' }}>
        <SettingsItem icon="🔔" text="Уведомления" onClick={() => console.log('Уведомления')} />
        <SettingsItem icon="🔍" text="Поиск" onClick={() => console.log('Поиск')} />
      </div>

      <div style={{ height: '1px', background: '#e4e4e5', margin: '0 15px' }} />

      {/* Медиа (заглушка) */}
      <div style={{ padding: '10px 0' }}>
        <SettingsItem icon="📷" text="Медиа" onClick={() => console.log('Медиа')} />
        <SettingsItem icon="📎" text="Файлы" onClick={() => console.log('Файлы')} />
        <SettingsItem icon="🔗" text="Ссылки" onClick={() => console.log('Ссылки')} />
      </div>

      <div style={{ height: '1px', background: '#e4e4e5', margin: '0 15px' }} />

      {/* Настройки (заглушки) */}
      <div style={{ padding: '10px 0' }}>
        <SettingsItem icon="🔇" text="Отключить уведомления" onClick={() => console.log('Mute')} />
        <SettingsItem icon="🗑️" text="Очистить историю" onClick={() => console.log('Clear')} />
        <SettingsItem icon="🚫" text="Заблокировать" onClick={() => console.log('Block')} danger />
      </div>
    </div>
  );
});

const SettingsItem = ({ icon, text, onClick, danger }) => (
  <div
    onClick={onClick}
    style={{
      padding: '12px 20px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      fontSize: '14px',
      color: danger ? '#dc3545' : '#333',
      transition: 'background 0.2s'
    }}
    onMouseEnter={(e) => e.currentTarget.style.background = '#f4f4f5'}
    onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
  >
    <span style={{ fontSize: '18px' }}>{icon}</span>
    <span>{text}</span>
  </div>
);

export default ChatSettings;